import { useState } from 'react';
import './styles.scss';
import cn from 'classnames';

const FAQuestion = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={cn('nurseQuestion', isOpen && 'nurseQuestionOpen')} onClick={() => setIsOpen(!isOpen)}>
      <span className={cn('nurseQuestionIcon', isOpen && 'nurseQuestionIconOpen')}>
        <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15 15' fill='none'>
          <path
            d='M1.5 7.33333H13.1667M7.33333 1.5V13.1667'
            stroke='#F39B38'
            stroke-width='3'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </svg>
      </span>
      <span className='nurseQuestionTitle'>{data.question}</span>
      {isOpen && <span className='nurseQuestionText'>{data.answer}</span>}
    </div>
  );
};

export default FAQuestion;
